import {TuiRoot} from "@taiga-ui/core";
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {catchError, of, Subject, switchMap, takeUntil} from 'rxjs';
import {EventsService} from './shared/services/events.service';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from './shared/services/auth.service';
import {ChatsService} from './shared/services/chats.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TuiRoot],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  eventsService = inject(EventsService);
  toastrService = inject(ToastrService);
  router = inject(Router)
  authService = inject(AuthService);
  chatsService = inject(ChatsService);

  destroy$ = new Subject();

  ngOnInit(): void {
  }

  constructor() {
    this.InitToastr();
    this.AuthCheck();
  }

  AuthCheck() {
    if (this.authService.HasTokens()) {
      this.authService.GetMe().pipe(
        switchMap(() => this.chatsService.getUnreadMessages()),
        catchError(err => {
          this.eventsService.throwError();
          return of(null);
        })
      ).subscribe();
    } else {
      this.authService.CLearSession();
      if (!window.location.href.includes('/auth')) {
        //console.log("1")
        this.router.navigate(['/auth']);
      }
    }
  }

  InitToastr() {
    this.eventsService.IsErrorChange$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((res: any) => {
        if (res && this.eventsService.Error.status) {
          this.toastrService.error(this.eventsService.Error.text, "Ошибка!", {
            positionClass: "toast-bottom-center",
            titleClass: 'title-toast'

          });
        } else {
          this.toastrService.clear();
        }
      })

    this.eventsService.IsSuccessChange$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((res) => {
        if (res && this.eventsService.Success.status) {
          this.toastrService.success(
            this.eventsService.Success.text,
            "Операция выполнена успешно",
            {
              positionClass: "toast-bottom-center",
              titleClass: 'title-toast'
            }
          );
        } else {
          this.toastrService.clear();
        }
      })
  }
}
